import DataContext from "./DataContext";
export default DataContext;